import React from "react";
import { Nav, NavItem, NavLink } from "shards-react";

import Notifications from "./Notifications";
import UserActions from "./UserActions";
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { taskboardslogout } from "../../../../../../actions/auth";
import Errors from "../../../../views/Errors";
import Spinner from "../../../../../layout-spinner/Spinner";

function NavbarNav({ auth: { taskboardsloading, taskboardsuser }, taskboardslogout }) {
  
  return ( taskboardsloading ? <Spinner /> : taskboardsloading === false && taskboardsuser !== null ?
    <React.Fragment>
    <Nav navbar className="md-mr-3 ml-auto navItems">
            <NavItem className = "mt-2">
                  {typeof taskboardsuser !== 'undefined' && taskboardsuser !==null && taskboardsuser.workspaceName !== null ? taskboardsuser.workspaceName : console.log('nada')}
            </NavItem>
              <NavItem>
              <NavLink className = "text-center mt-n2 mr-md-2" onClick={taskboardslogout} href='#!'>
              {(
                <div
                  className="d-inline-block item-icon-wrapper"
                  dangerouslySetInnerHTML={{ __html: '<i class="material-icons">logout</i>' }}
                />)}
              {<span>{" Logout"}</span>}
                </NavLink>
            </NavItem>
    {/* <Notifications /> */}
    {/* <UserActions /> */}
  </Nav>
  </React.Fragment> : <Errors />
  )
}


NavbarNav.propTypes = {
  taskboardslogout: PropTypes.func.isRequired,
  taskboardsauth: PropTypes.object.isRequired
};

const mapStateToProps = state => ({
  auth: state.auth
});

export default connect(
  mapStateToProps,
  { taskboardslogout }
)(NavbarNav);



